<template>
  <div id="GlobalStatsCard" class="global-static-cards">
    <base-card
      :id-tag="cardName"
      :title="title"
      :card-type="!cardName ? 'nonpinnable' : 'pinnable'"
      :module-icon="gsHeaderIcon"
      :display-order="displayOrder"
      :api-endpoints="apiEndpoints"
      :user-guide-identifier="userGuideIdentifier"
      @MoveCardUp="$emit('MoveCardUp', displayOrder)"
      @MoveCardDown="$emit('MoveCardDown', displayOrder)"
    >
      <template #chart>
        <v-layout row class="UDM_GS_Count_Row">
          <v-flex
            v-for="(groupProps, groupLabel) in sanitizedStatsGroups"
            :key="groupLabel"
            class="global-stats-group"
          >
            <slot name="above-stats" />
            <header
              :class="['text-center subheading', groupLabel ? 'pt-2' : '']"
            >
              {{ groupLabel }}
            </header>
            <v-layout row>
              <v-flex
                v-for="prop in groupProps"
                :key="prop"
                class="pa-3 global-stats-flex"
                @mouseenter="emitHoverEvent(prop)"
              >
                <slot
                  :name="`${prop}-card`"
                  :value="globalStats[prop]"
                  :cardName="rename[prop] || prop"
                >
                  <p
                    v-if="!hideGsPropName"
                    :id="'SB_GS_Label_' + prop"
                    class="subheading text-xs-center mb-0"
                  >
                    {{ rename[prop] || prop }}
                  </p>
                  <div
                    v-if="globalStatsLink"
                    class="subheading text-xs-center font-weight-bold"
                  >
                    <h2>
                      <router-link
                        :id="'SB_GS_' + prop"
                        :to="globalStats[prop].link"
                      >
                        {{ globalStats[prop].text }}
                      </router-link>
                    </h2>
                  </div>
                  <div v-else class="subheading text-xs-center">
                    <slot :name="`${prop}-body`" :value="globalStats[prop]">
                      <h2 :id="'SB_GS_' + prop" class="mb-0">
                        {{ globalStats[prop] }}
                      </h2>
                    </slot>
                  </div>
                </slot>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </base-card>
  </div>
</template>
<script>
/**
 * This component is used for global stats card.
 *
 * Example usage
 * <global-stats-navbar
 *   :globalStats="globalStatsObject" //Json object
 *   :rename = "renameObject"//If needed the property names of global stats can be renamed
 * >
 *  <template #Groups-body="{ value }">// If stats has any other features like link instead of just a number
        <h2 id="AD_GS_GroupsCount">
          <a :href="`${SbBaseUrl}/ADGroup#/GroupDetails`">{{ value }}</a>
        </h2>
      </template>
 * </global-stats-navbar>
 */
import BaseCard from '../components/BaseCard.vue';

export default {
  name: 'GlobalStatsNavbar',
  components: {
    BaseCard,
  },
  props: {
    displayOrder: {
      type: Number,
      default: undefined,
    },
    title: {
      type: String,
      default: 'Global Stats',
    },
    userGuideIdentifier: {
      type: Object,
      default: () => ({}),
    },
    cardName: {
      type: String,
      default: undefined,
    },
    gsIdPrefix: {
      type: String,
      default: 'SB_GlobalStats',
    },
    gsHeaderIcon: {
      type: String,
      default() {
        return '';
      },
    },
    globalStats: {
      type: Object,
      default() {
        return {};
      },
    },
    statsGroups: {
      type: Object,
      default() {
        return {};
      },
    },
    rename: {
      type: Object,
      default() {
        return {};
      },
    },
    hideGsPropName: {
      type: Boolean,
    },
    globalStatsLink: {
      type: Boolean,
    },
    hidePinIcon: {
      type: Boolean,
    },
    apiEndpoints: {
      type: Array,
      required: true,
      validator(value) {
        if (!(value instanceof Array)) return false;
        return value.filter((v) => typeof v !== 'string').length === 0;
      },
    },
  },
  computed: {
    sanitizedStatsGroups() {
      // maybe do this so any props in globalStats but not in statsGroups will go into an empty label bucket
      if (Object.keys(this.statsGroups).length === 0) {
        return { '': Object.keys(this.globalStats) };
      }
      return this.statsGroups;
    },
  },
  methods: {
    emitHoverEvent(value) {
      this.$emit('hover', value);
    },
  },
};
</script>
<style>
@import '../static/css/Components/GlobalStatsNavbar.css';

.global-stats-group:not(:last-of-type) {
  border-right: 1px solid lightgray;
}
</style>
